import moment from 'moment'
import _ from 'lodash'
import store from '../store';
import psalms from '../data/psalm.const';

export default class Week {
    cluster;
    index;
    days;

    constructor(days, cluster) {
        this.cluster = cluster;
        this.index = parseInt(days[0].localDate.format('w'));
        this.days = days;
        this.setDefaultLessons();
    }

    setDefaultLessons() {
        const kerstmisWeek = moment(store.getters['rooster/holiday']('kerstmis').start_date).week();
        const goedeVrijdagWeek = moment(store.getters['rooster/holiday']('goede_vrijdag').start_date).week();
        const pasenWeek = moment(store.getters['rooster/holiday']('pasen').end_date).week();
        const hemelvaartWeek = moment(store.getters['rooster/holiday']('o.l.h._hemelvaart').start_date).week();
        const pinksterWeek = moment(store.getters['rooster/holiday']('pinksteren').end_date).week()

        // Explanation: inRange(this.index - weekTarget, weeksBefore, weeksAfter);

        // Lessons start 2 weeks before christmas 
        if (_.inRange(this.index - kerstmisWeek, -2, 0)) {
            this.days.forEach(day => day.autofill(this.cluster, 'advent', null, true));
        }

        // Lessons start 2 weeks before good friday and the week itself
        if (_.inRange(this.index - goedeVrijdagWeek, -2, 1)) {
            this.days.forEach(day => day.autofill(this.cluster, 'lijden', null, true));
        }
        // Lessons are twee weeks after easter
        if (_.inRange(this.index - pasenWeek, 0, 2)) {
            this.days.forEach(day => day.autofill(this.cluster, 'pasen', null, true));
        }

        if (this.index === hemelvaartWeek) {
            this.days.forEach(day => day.autofill(this.cluster, 'hemelvaart', null, true));
        }
        if(this.index === pinksterWeek) {
            this.days.forEach(day => day.autofill(this.cluster, 'pinksteren', null, true));
        }
        this.days.forEach(day => {
            if (!day.isHoliday()) {
                if (day.isMonday()) {
                    const psalmsForweek = this.getPsalms(this.cluster);
                    if (psalmsForweek.length) {
                        day.setLesson('#6c757d', '#fff', null, psalmsForweek);
                    }
                }

                if (day.isFriday() && day.hasVerwerking()) {
                    day.setVerwerking();
                } else if (day.isFriday() && this.cluster === 'cluster_3') {
                    const fridayLesson = store.getters['rooster/kerkenzending'] ? "kerk_en_zending" : "nederlandse_geloofsbelijdenis";

                    const index = store.getters['rooster/lessonIndex'](this.cluster + "_" + fridayLesson);
                    day.autofill(this.cluster, fridayLesson, index, false, true);
                    day.setColorFromType(this.type);
                    store.commit('rooster/INCREASE_LESSON_INDEX', this.cluster + '_' + fridayLesson);
                }
            }
        });
    }

    getPsalms(cluster) {
        switch (cluster) {
            case 'cluster_1':
                return [this.getNextPsalm('group_1'), this.getNextPsalm('group_2')];
            case 'cluster_2':
                return [
                    this.getNextPsalm('group_3'),
                    this.getNextPsalm('group_4'),
                    this.getNextPsalm('group_5'),
                ];
            case 'cluster_3':
                return [
                    this.getNextPsalm('group_6'),
                    this.getNextPsalm('group_7'),
                    this.getNextPsalm('group_8'),
                ];
            default:
                return [];
        }
    }

    getNextPsalm(group) {
        const key = this.cluster + group + '_psalm_index';
        const index = store.getters['rooster/lessonIndex'](key);
        const psalm = psalms[group][index];
        if (psalm) {
            store.commit('rooster/INCREASE_LESSON_INDEX', key);
        }
        return psalm;
    }
}